<template>
  <div class="content minutas p-1">
    <h4 class="minutas_title">
      <b>Minutas de anotações / averbações</b>
    </h4>

    <div class="pl-3 pr-3">
      <b-row align-h="between">
        <div class="ml-3 mt-1 col-4 p-0">
          <div class="form-group">
            <label for="busca"
                   class="minutas_label">Busca minuta</label>
            <input id="busca_minuta"
                   ref="busca_minuta"
                   v-model="search"
                   class="col-md-12 form-control form-control-sm"
                   name="busca_minuta"
                   placeholder="Digite o título da minuta"
                   type="text">
          </div>
        </div>
        <div>
          <div class="mt-3 mr-3">
            <b-button ref="minuta_add"
                      variant="secondary"
                      size="sm"
                      @click="showModal()">
              <svg class="button_add_icon icon--xxs"
                   role="presentation">
                <use :xlink:href="'#' + add.id" />
              </svg>
              Adicionar minuta
            </b-button>
          </div>
        </div>
      </b-row>
      <Table
        :fields="fields"
        :data="minutas"
        :is-busy="isBusy"
        :search="search"
        field-search="titulo"
        @showModal="showModal"
        @deleteItem="deleteMinutas"
        @onUpdateAtivo="updateAtivo" />

      <Pagination
        :per-page="perPage"
        :page="page"
        :last-page="lastPage"
        @onPreviousPage="previousPage"
        @onNextPage="nextPage" />

      <form autocomplete="off"
            class="no-padding"
            @submit.prevent="callMethod()">
        <b-modal
          id="modal-cadastro"
          no-close-on-backdrop
          no-close-on-esc
          size="lg"
          class="no-padding"
          hide-header
          @show="showModalMinutas">
          <template v-slot:modal-footer>
            <div class="w-100">
              <b-row align-h="end">
                <b-button
                  size="sm"
                  class="btn btn-sm btn_voltar"
                  variant="outline"
                  @click="$bvModal.hide('modal-cadastro')">
                  Voltar
                </b-button>
                <b-button
                  size="sm"
                  type="submit"
                  class="mr-3"
                  :disabled="!form.titulo || !form.descricao">
                  {{ form.editar ? "Atualizar" : "Adicionar" }}
                </b-button>
              </b-row>
            </div>
          </template>

          <div class="col-7">
            <div class="row align-items-center">
              <div
                role="group"
                class="col-7 form-group">
                <label
                  for="input-live"
                  class="label">Tipo de registro</label>
                <select id="tipo_registro_minuta"
                        ref="tipo_registro_minuta"
                        v-model="form.tipo_registro"
                        class="form-control form-control-sm"
                        name="tipo_registro_minuta">
                  <option v-for="(tipo, index) in tipoRegistro"
                          :key="`tipo_registro_${_uid}_${index}`"
                          :value="tipo.key">
                    {{ tipo.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="row align-items-center">
              <div
                role="group"
                class="col-12 form-group">
                <label
                  for="input-live"
                  class="label">Título</label>
                <input
                  v-model="form.titulo"
                  class="form-control form-control-sm"
                  placeholder="Insira o Título">
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="row align-items-center">
              <div
                role="group"
                class="col-12 form-group">
                <label
                  for="input-live"
                  class="label">Descrição</label>
                <b-form-textarea
                  v-model="form.descricao"
                  placeholder="Insira a descrição"
                  rows="4"
                  no-resize />
              </div>
            </div>
          </div>
        </b-modal>
      </form>
    </div>
  </div>
</template>
<script>
  /* components */
  import Table from '@/components/SofiaRei/Table'
  import Pagination from '@/components/SofiaRei/Pagination'

  /* services  */
  import MinutasService from "@/services/MinutasService"

  /* assets */
  import add from '@/assets/icons/add.svg?sprite'
  import editIcon from "@/assets/icons/pencil.svg?sprite"
  import trash from "@/assets/icons/trash.svg?sprite"
  import eyeIcon from "@/assets/icons/eye.svg?sprite"

  /* outros */
  import _ from 'lodash'
  import { mapGetters } from 'vuex'


  export default {
    name: 'Minutas',
    components: {
      Table,
      Pagination,
    },
    data () {
      return {
        search: null,
        isBusy: false,
        perPage: 10,
        page: 1,
        lastPage: 1,
        add,
        editIcon,
        trash,
        eyeIcon,
        read: false,
        title: 'Nova Minuta',
        fields: [
          {
            key: 'id',
            label: 'Ativo',
            sortable: true
          },
          {
            key: 'titulo',
            label: 'Título',
            sortable: true
          },
          {
            key: 'tipo_registro_extenso',
            label: 'Tipo de registro',
            sortable: true
          },
          {
            key: 'acoes2',
            label: '',
            sortable: false
          }
        ],
        tipoRegistro: [
          {
            key: 'O',
            name: 'Óbito'
          },
          {
            key: 'NT',
            name: 'Natimorto'
          },
          {
            key: 'N',
            name: 'Nascimento'
          },
          {
            key: 'D',
            name: 'Habilitação de Casamento'
          },
          {
            key: 'C',
            name: 'Casamento'
          }
        ],
        minutas: [],
        form: {
          titulo: null,
          descricao: null,
          tipo_registro: null,
          editar: null,
          ativo: true
        }
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      }),
    },
    watch: {
      search: function (newSearch, oldSearch) {
        this.isBusy = true
        this.viewWatch()
      }
    },
    created () {
      this.viewWatch = _.debounce(function () {
        this.searchMinuta()
      }, 200)
    },
    beforeMount () {
      try {
        loader({text: "Obtendo dados...", active: true})
        this.init()
      } catch (error) {
        loader({text: "", active: false})
      }
    },
    mounted () {
      this.$refs['busca_minuta'].focus()
    },
    methods: {
      async init () {
        const minutas = await MinutasService.getMinuta ({
          cartorio_id: this.$store.state.auth.cartorio_id,
          perPage: this.perPage,
          page: this.page
        })

        this.minutas = minutas.data

        if (!!this.minutas.length) {
          this.minutas = this.minutas.map((minuta) => {
            switch (minuta.tipo_registro) {
            case 'O': minuta.tipo_registro_extenso = 'Óbito'; break
            case 'NT': minuta.tipo_registro_extenso = 'Natimorto'; break
            case 'N': minuta.tipo_registro_extenso = 'Nascimento'; break
            case 'D': minuta.tipo_registro_extenso = 'Habilitação de Casamento'; break
            case 'C': minuta.tipo_registro_extenso = 'Casamento'; break
            default: minuta.tipo_registro_extenso = ''; break
            }

            return minuta
          })
        }

        this.lastPage = minutas.lastPage
        this.isBusy = false

        loader({ text: "", active: false})
      },
      async showModal (minuta = { data: {}, read: false }) {
        const { data, read } = minuta
        this.read = read

        if (data.minuta_id) {
          this.form = {
            ...this.form,
            minuta_id: data.minuta_id,
            titulo: data.titulo,
            descricao: data.descricao,
            ativo: data.ativo,
            editar: true,
            tipo_registro: data.tipo_registro
          }
        } else {
          this.form = {
            cartorio_id: this.$store.state.auth.cartorio_id,
            titulo: null,
            descricao: null,
            ativo: true,
            tipo_registro: 'O'
          }
        }

        this.$bvModal.show('modal-cadastro')
      },
      showModalMinutas () {
        setTimeout(() => {
          this.$refs['tipo_registro_minuta'].focus()
        }, 50)
      },
      async callMethod () {
        this.$bvModal.hide('modal-cadastro')
        loader({ text: "Aguarde...", active: true})

        this.form.minuta_id ? this.updateMinutas(this.form) : this.saveMinuta(this.form)
      },
      async saveMinuta (minuta) {
        try {
          const data = await MinutasService.saveMinuta (minuta)

          if (data.minuta_id) {
            this.init()
            await this.onSuccess('Salvo com sucesso!')
          } else {
            await this.onError('Erro ao salvar, tente novamente!')
          }
        } catch (err) {
          await this.onError('Erro ao salvar, tente novamente!')
        } finally {
          loader({ text: "", active: false})
          this.$refs['busca_minuta'].focus()
        }
      },
      async updateMinutas (minuta, alert = true) {
        try {
          const { minuta_id } = minuta

          minuta.cartorio_id = this.$store.state.auth.cartorio_id

          const data = await MinutasService.updateMinuta (minuta, minuta_id)

          if (minuta_id) {
            if (alert) {
              this.init()
              await this.onSuccess('Editado com sucesso!')
            }
          } else {
            await this.onError('Erro ao editar, tente novamente!')
          }

          const indexMinuta = this.minutas.findIndex(minuta => minuta.minuta_id = data.minuta_id)

          this.minutas[indexMinuta].ativo = data.ativo ? 1 : 0
        } catch (err) {
          await this.onError('Erro ao editar, tente novamente!')
        } finally {
          loader({ text: "", active: false })
          this.$refs['busca_minuta'].focus()
        }
      },
      async searchMinuta () {
        this.isBusy = true

        const minutas = await MinutasService.getMinuta({
          cartorio_id: this.$store.state.auth.cartorio_id,
          titulo: this.search
        })

        this.minutas = minutas.data
        this.lastPage = minutas.lastPage
        this.isBusy = false
      },
      previousPage () {
        this.isBusy = !this.isBusy
        this.page -= 1
        this.init()
      },
      nextPage () {
        this.isBusy = !this.isBusy
        this.page += 1
        this.init()
      },
      updateAtivo (data) {
        this.updateMinutas(data, false)
      },
      onSuccess (title = 'Realizado com sucesso!', text = '') {
        objSwal.success.title = title
        objSwal.success.text = text
        objSwal.success.html = ''

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 300)

        return Swal.fire(objSwal.success).then((res) => {
          objSwal.success.title = ''
          objSwal.success.text = ''
          objSwal.success.html = ''

          return res
        })
      },
      onError (title = 'Erro', text = '') {
        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = ''

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 300)

        return Swal.fire(objSwal.error).then((res) => {
          objSwal.error.title = ''
          objSwal.error.text = ''
          objSwal.error.html = ''

          return res
        })
      },
      deleteMinutas (val) {
        objSwal.question.title = ''
        objSwal.question.text = 'Confirma a exclusão desta minuta?'
        objSwal.question.html = ''

        setTimeout(() => {
          const btnCancel = document.querySelector('.swal2-cancel')

          if (btnCancel) btnCancel.focus()
        }, 300)

        return Swal.fire (objSwal.question).then(result => {
          if (result.value) {
            MinutasService.excludeMinuta(val.minuta_id).then(async res => {
              this.init()
              await this.onSuccess('Excluída com sucesso!')
              this.$refs['busca_minuta'].focus()
            }).catch(({ message }) => this.onError(`Erro ao deletar minuta.`, message))
          }
        })
      },
    }
  }

</script>
<style lang="scss">
  @import "../../scss/_utilities/_exports";

  .minutas{
    &_title {
      background-color: $sinoreg-blue;
      color: $color-white;
      font-size: pxToRem(24);
      font-weight: 500;
      padding: pxToRem(10) pxToRem(20);
    }

    &_label {
      font-size: pxToRem(16);
    }
  }

  .button_add_icon {
    fill: white;
  }
</style>
